








































































































import { logout } from "../../utils/logout";
import { AuthApi, UsersApi } from "../../apis";
import { auth, microsoftProvider } from "../../firebase";
export default {
  data() {
    return {
      loading: false,
      microsoftLoading: false,
      loginForm: {
        email: "",
        password: "",
      },
      emailRules: [
        (v) => !!v || this.$t("text.email-is-required"),
        (v) => /.+@.+\..+/.test(v) || this.$t("text.email-must-be-valid"),
      ],
      passwordRules: [
        (v) => !!v || this.$t("text.password-is-required"),
        (v) => v.length >= 8 || this.$t("text.password-length"),
      ],
      errorMessage: "",
      showPassword: false,
      fullName: "",
    };
  },
  methods: {
    clearErrorMessage() {
      this.errorMessage = "";
    },
    handleForgotPassword() {
      // Navigate to forgot password page or show forgot password dialog
      this.$router.push({ path: "/forgot-password" });
    },
    async handleLogin() {
      if (!this.$refs.loginForm.validate()) return;
      this.loading = true;
      this.errorMessage = "";
      // this.$store.commit("SET_IS_LOGGED_IN_VIA_MICROSOFT", false);
      try {
        const result: any = await new AuthApi()
          .login({
            postSessionRequest: {
              email: this.loginForm.email,
              password: this.loginForm.password,
              language: "en",
            },
          })
          .catch((error) => {
            this.errorMessage = this.$t("text.invalid-email-or-password");
          });
        const { data } = result.data;
        this.$store.commit("SET_SP_USER_INFO", {
          email: this.loginForm.email,
          fullName: data.fullName,
        });
        if (result.status === 200) {
          await this.updateUser(data.fullName, this.loginForm.email);
        }
        window.localStorage.setItem("isLoggedIn", "true");
      } catch (error) {
        console.error("Login error:", error);
      } finally {
        this.loading = false;
      }
    },
    async loginWithMicrosoft() {
      this.microsoftLoading = true;
      // this.$store.commit("SET_IS_LOGGED_IN_VIA_MICROSOFT", true);
      try {
        const result = await auth.signInWithPopup(microsoftProvider);
        const { displayName } = result.user;
        const credential: any = result.credential;
        const accessToken = credential ? credential.accessToken : null;
        
        const response = await fetch("https://graph.microsoft.com/v1.0/me", {
          headers: { Authorization: `Bearer ${accessToken}` }
        });
        const profile = await response.json();
        const email = profile.mail;
        
        this.$store.commit("SET_SP_USER_INFO", {
          email: email,
          token: accessToken,
          fullName: displayName,
        });
        
        const data = await new AuthApi().checkV2({
          postLoginWithMsRequest: {
            email: email,
            password: email,
            fullName: displayName,
            language: "en",
          },
        });
        
        if (data.status === 200) {
          await this.updateUser(displayName, email);
        }
        window.localStorage.setItem("isLoggedIn", "true");
        this.microsoftLoading = false;
      } catch (error) {
        console.error("Microsoft login error:", error);
        this.microsoftLoading = false;
      }
    },
    async updateUser(fullName: string, email: string) {
      const errorCb = (error) => {
        console.log(
          `Fail CheckingLoginSessionPage ${email}. Error: ${error.statusText} `
        );
        this.$util.showError("check_session_fail");
        this.showDialog = false;
      };
      const responseCb = async (val: any) => {
        if (val.status === 200) {
          const { user, permissions } = val.data.data;
          if (
            ["INACTIVE", "NEW"].includes(user.status.toUpperCase()) ||
            this.lodash.isEmpty(user.groups)
          ) {
            this.$router.push({ path: "/waiting-approve" });
            await logout(this.$store, this.$router, false);
            return;
          }
          new UsersApi()
            .putDoSyncUser({
              id: user.id,
              putSpUser: {
                fullName: fullName,
                spId: email,
              },
            })
            .catch((error) => {
              console.log(
                `Fail putDoSyncUser ${email}. Error: ${error.statusText} `
              );
            });
          this.$store.commit("SET_USER_INFO", { user });
          this.$store.commit("SET_PERMISSIONS", { permissions });
          setTimeout(() => {
            if (this.$screen.isMobile()) {
              this.$router.push({ path: "/treatments/requests" });
            } else {
              this.$router.push({ path: "/home" });
            }
          }, 500);
        } else if (!this.lodash.isEmpty(this.spUser)) {
          new UsersApi()
            .postDoSyncUser({
              spUser: {
                id: email,
                mail: email,
                displayName: fullName,
              },
            })
            .catch((error) => {
              console.log(
                `Fail postDoSyncUser ${email}. Error: ${error.statusText} `
              );
            });
        }
      };
      new UsersApi()
        .getCheckUser({ email: email })
        .then(responseCb)
        .catch(errorCb);
    },
  },
};
